import React, { useState, useEffect, useRef } from 'react';
import './Navbar.css';
import { FiMenu, FiX, FiBriefcase, FiInfo, FiPhone, FiTarget } from 'react-icons/fi';
import YourLogo from '../../Assets/adhvikandadhrit-logo.png'; // IMPORTANT: Place your logo image in src/assets/ and update path
import name from "../../Assets/name.png"
const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const navbarRef = useRef(null);

  const navItems = [
    { id: 'home', label: 'Home', targetId: '/' },
    { id: 'about', label: 'About', targetId: '/about' },
    { id: 'why-us', label: 'Why Us',  targetId: '/whyus' },
    { id: 'contact', label: 'Contact',  targetId: '/contact' },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
    document.body.classList.toggle('no-scroll', !isMobileMenuOpen); // Prevent body scroll when mobile menu is open
  };

  const handleLinkClick = (targetId) => {
    setIsMobileMenuOpen(false);
    document.body.classList.remove('no-scroll');
    setActiveSection(targetId);
    const element = document.getElementById(targetId);
    if (element) {
      const navbarHeight = navbarRef.current ? navbarRef.current.offsetHeight : 70;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navbarHeight - 20;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);

      let currentSectionId = 'philosophy';
      const navbarHeight = navbarRef.current ? navbarRef.current.offsetHeight : 70;
      
      // Check sections in reverse order for more accurate bottom-up detection
      for (let i = navItems.length - 1; i >= 0; i--) {
        const item = navItems[i];
        const element = document.getElementById(item.targetId);
        if (element) {
          const rect = element.getBoundingClientRect();
          // Consider a section active if its top is within a certain range from the top of the viewport
          // or if it's the topmost visible section
          if (rect.top <= navbarHeight + window.innerHeight * 0.5 && rect.bottom >= navbarHeight + 50) {
             currentSectionId = item.targetId;
             break; // Found the active section
          }
        }
      }
      // Fallback if no section is prominently in view (e.g., very top or bottom of page)
      if (scrollPosition < 100) currentSectionId = 'philosophy';

      setActiveSection(currentSectionId);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.classList.remove('no-scroll'); // Cleanup on unmount
    };
  }, [navItems]);


  return (
    <header 
      ref={navbarRef} 
      className={`navbar-advanced ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'mobile-menu-bg-active' : ''}`}
    >
      <div className="navbar-container-advanced">
        <a href="/" className="navbar-logo-advanced" onClick={() => handleLinkClick('philosophy')}>
          <img src={YourLogo} alt="Adhvik and Adhrit Consultants Services" className="logo-image" />
          {/* Optional: Add company name if logo is just a mark, styled differently */}
          <span className="logo-brand-name">  <img src={name} alt="Adhvik and Adhrit Consultants Services" className="logo-image" /></span>
        </a>

        <nav className={`navbar-nav-advanced ${isMobileMenuOpen ? 'open' : ''}`}>
          <div className="nav-wrapper-advanced"> {/* For mobile menu inner styling */}
            <ul style={{color:"black"}}>
              {navItems.map((item, index) => (
                <li 
                  key={item.id} 
                  className={activeSection === item.targetId ? 'active-nav-item-advanced' : ''}
                  style={{ animationDelay: `${isMobileMenuOpen ? index * 0.1 + 0.2 : 0}s` }} /* Stagger for mobile */
                >
                  <a href={`${item.targetId}`} onClick={() => handleLinkClick(item.targetId)}>
                    <span className="nav-label-advanced">{item.label}</span>
                    <span className="nav-icon-advanced">{item.icon}</span>
                  </a>
                </li>
              ))}
            </ul>
            {/* Optional: Social links or CTA in mobile menu */}
            {isMobileMenuOpen && (
              <div className="mobile-menu-footer">
                <p>© {new Date().getFullYear()} Dheer Software Solutions</p>
              </div>
            )}
          </div>
        </nav>

        <button 
          className="mobile-menu-toggle-advanced" 
          onClick={toggleMobileMenu} 
          aria-label="Toggle Menu"
          aria-expanded={isMobileMenuOpen}
        >
          <div className={`hamburger-icon-advanced ${isMobileMenuOpen ? 'open' : ''}`}>
            <span style={{background:"black"}}></span>
            <span style={{background:"black"}}></span>
          </div>
        </button>
      </div>
    </header>
  );
};

export default Navbar;